import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import {
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  useDisclosure,
} from '@chakra-ui/react';

import { RefType, AlertProps } from './Alert.props';

const AlertView = forwardRef<RefType, AlertProps>((props, ref) => {
  const {
    onCancelClick,
    onSaveClick,
    title,
    body,
    button1,
    button2,
    closeOnOverlayClick = true,
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  useImperativeHandle(
    ref,
    () => ({
      isOpen,
      onOpen,
    }),
    [onOpen],
  );

  return (
    <>
      <AlertDialog
        closeOnOverlayClick={closeOnOverlayClick}
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {title}
            </AlertDialogHeader>

            <AlertDialogBody>{body}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                variant="outline"
                ref={cancelRef}
                onClick={() => {
                  onCancelClick?.();
                  onClose();
                }}>
                {button1}
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  onSaveClick?.();
                  onClose();
                }}
                ml={3}>
                {button2}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
});

export default AlertView;
